import { ObjectUtils } from '../utils/ObjectUtils';

export {};

Array.prototype.generateArrayByLength = function (length: number, startFromZero = false): number[] {
  return Array.from({ length }, (_, i) => i + (startFromZero ? 0 : 1));
};

Array.prototype.sortByKey = function <T>(key: keyof T, sortingType: 'asc' | 'desc' = 'asc'): T[] {
  if (key && sortingType) {
    let sortedData: T[] = [];

    const extractNumber = (value: string): { prefix: string, number: number } => {
      const numberStart = value.search(/\d/);
      if (numberStart === -1) return { prefix: value, number: null };

      const prefix = value.substring(0, numberStart);
      const number = Number(value.substring(numberStart));
      return { prefix, number };
    };

    const compareValues = (aValue: any, bValue: any) => {
      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        const aExtracted = extractNumber(aValue);
        const bExtracted = extractNumber(bValue);

        if (bExtracted.number && aExtracted.number) {
          return sortingType === 'asc'
          ? aExtracted.number - bExtracted.number
            : bExtracted.number - aExtracted.number;
        } else {
        return sortingType === 'asc'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
        }
      }

      const aParsed = !isNaN(Number(aValue)) ? Number(aValue) : aValue;
      const bParsed = !isNaN(Number(bValue)) ? Number(bValue) : bValue;

      if (typeof aParsed === 'number' && typeof bParsed === 'number') {
        return sortingType === 'asc'
          ? aParsed - bParsed
          : bParsed - aParsed;
      }

      if (aParsed < bParsed) return sortingType === 'asc' ? -1 : 1;
      if (aParsed > bParsed) return sortingType === 'asc' ? 1 : -1;
      return 0;
    };

    sortedData = this.sort((a: T, b: T) => {
      const aKey = a[key];
      const bKey = b[key];

      const aValue = typeof key === 'string' && key.includes('.') ? ObjectUtils.getObjectValue(a, key) : typeof aKey === 'string' ? (aKey as string)?.toUpperCase() : aKey;
      const bValue = typeof key === 'string' && key.includes('.') ? ObjectUtils.getObjectValue(b, key) : typeof bKey === 'string' ? (bKey as string)?.toUpperCase() : bKey;
      return compareValues(aValue, bValue);
    });

    return sortedData;
  } else {
    return this;
  }
};

Array.prototype.generateArrayByLength = function (length: number, startFromZero = false): number[] {
  return Array.from({ length }, (_, i) => i + (startFromZero ? 0 : 1));
};
